import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
  name: "patient",
  initialState: {
    value: {
      firstName: "Initial firstName",
      surname: "Initial surname",
      name: "Initial name",
      id: "0",
      dob: "0",
      nhsNumber: "0",
      parentName: "0",
      relationship: "0",
      gender: 0,
      bloodGroup: "0",
      height: "0",
      weight: "0",
      city: "0",
      address: "0",
      postcode: "0",
    },
  },
  reducers: {
    selected: (state, action) => {
      state.value = action.payload; //payload contains the new values
    },
  },
});

export const { selected } = userSlice.actions;

export default userSlice.reducer;
